export default __webpack_public_path__ + "static/media/employee6.86ccfaac.png";